import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
import { useAuthContext } from '../hooks';

const loginPaths = {
  jwt: paths.auth.jwt.pharmacy_login,
};

export default function PharmacyAuthGuard({ children, allowedPharmacyId }) {
  const router = useRouter();
  const { authenticated, user, method } = useAuthContext();
  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!authenticated) {
      const searchParams = new URLSearchParams({ returnTo: window.location.pathname }).toString();
      const loginPath = loginPaths[method];
      router.replace(`${loginPath}?${searchParams}`);
    } else if (allowedPharmacyId && user?.pharmacy_id !== allowedPharmacyId) {
      alert('User access denied');
      router.replace(paths.pharmacy_dashboard.root);
    } else {
      setChecked(true);
    }
  }, [authenticated, user, allowedPharmacyId, method, router]);

  useEffect(() => {
    check();
  }, [check]);

  if (!checked) return null;

  return <>{children}</>;
}

PharmacyAuthGuard.propTypes = {
  children: PropTypes.node,
  allowedPharmacyId: PropTypes.string,
};
